/**
 * Bell notices: the small state changes the bell makes when a person reads a notice.
 * Pure, so they can be tested without a browser.
 */
import type { UserNotice } from '../services/notices.service';

export interface NoticeState {
  notices: UserNotice[];
  unread: number;
}

/** Marks one notice read. Already-read or unknown ids change nothing, and unread never goes below 0. */
export function withNoticeRead(state: NoticeState, id: string, nowIso: string): NoticeState {
  const target = state.notices.find((n) => n.id === id);
  if (!target || target.read_at) return state;
  return {
    notices: state.notices.map((n) => (n.id === id ? { ...n, read_at: nowIso } : n)),
    unread: Math.max(0, state.unread - 1),
  };
}

/** Marks every notice read. */
export function withAllNoticesRead(state: NoticeState, nowIso: string): NoticeState {
  return { notices: state.notices.map((n) => (n.read_at ? n : { ...n, read_at: nowIso })), unread: 0 };
}

/** What the bell badge counts: pending work plus unread notices. */
export function bellBadgeTotal(parts: { pendingWfh: number; pendingLeave: number; unreadAnnouncements: number; unreadNotices: number }): number {
  return parts.pendingWfh + parts.pendingLeave + parts.unreadAnnouncements + parts.unreadNotices;
}
